import { isString } from 'lodash';
import { Duration } from 'luxon';
import { formatNumber } from '../operators';
import { formatDistanceString } from './distance';
import { getPortalLanguage, kphToMph } from './locale';

export const formatValue = (value: number | string, formatter?: string, unit: 'metric' | 'imperial' = 'metric'): string => {
  const converted = isString(value) ? parseInt(value, 10) : value;
  const lang = getPortalLanguage();

  switch (formatter) {
    case 'distance': {
      return formatDistanceString(converted, 'kilometer', 'short');
    }
    case 'speed': {
      const isImperial = unit === 'imperial';
      const speed = isImperial ? kphToMph(converted) : converted;
      return Intl.NumberFormat(lang, { maximumFractionDigits: 0 }).format(speed) + (isImperial ? ' mph' : ' km/h');
    }
    case 'duration': {
      return Duration.fromObject({ minutes: converted }, { locale: lang }).shiftTo('hours', 'minutes').toHuman({ unitDisplay: 'long' });
    }
    case 'percentage': {
      const clamped = Math.max(0, Math.min(100, converted));
      return formatNumber({ value: clamped, format: 'percentage-100' }) || '';
    }
    case 'currency': {
      return Intl.NumberFormat(lang, { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' }).format(converted);
    }
    default:
      return Intl.NumberFormat(lang, { maximumFractionDigits: 0 }).format(converted);
  }
};
